import { withBlockExtensions } from '@plone/volto/helpers';
import config from '@plone/volto/registry';
import cx from 'classnames';

const HeadingView = (props) => {
  const { className, data } = props;
  const Element = data.tag || 'h2';
  const showAlignment =
    config.blocks?.blocksConfig?.junts_heading?.show_alignment;
  const showUnderline = data.showUnderline;
  return (
    <>
      {data && (
        <div className={cx('block', className)}>
          <div
            className={cx('junts-heading-wrapper', {
              'junts-heading-wrapper-underline': showUnderline,
            })}
          >
            <Element
              style={showAlignment ? { textAlign: data.alignment } : {}}
              className="junts-heading"
            >
              {data?.heading || ''}
            </Element>
          </div>
        </div>
      )}
    </>
  );
};

export default withBlockExtensions(HeadingView);
